<modal #modal
        modalClass="modal-lg modal-md"
        [hideCloseButton]="false"
        [closeOnEscape]="false"
        [closeOnOutsideClick]="false"
        (onClose)="handleClose()">
 
    <modal-header class="w-100 text-center">
        <h4 class="h4-responsive modal-title text-center">Subscription Required</h4>
    </modal-header>
 
    <modal-content class="container-fluid d-block">
        <div class="row">
            <div class="col text-center">
                <p>The action you have requested requires an active subscription.</p>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <input type="button" class="btn btn-primary" value="Activate your Subscription Today!" (click)="goToSubscriptionSignup()" />
            </div>
        </div>
    </modal-content>
 
    <modal-footer></modal-footer>
        
</modal>


// WEBPACK FOOTER //
// ./src/app/admin/subscription-dialog/subscription-dialog.component.html